import { DialogService } from 'primeng/dynamicdialog';
import { ComponentType } from '@angular/cdk/portal';
import { map } from 'rxjs';
import { DynamicDialog } from '../../domains/dialogs/dynamic-dialog';

export const createDialogHook =
  <R>(dialogComponent: ComponentType<DynamicDialog<R>>) =>
  (dialogService: DialogService, inputValues: Record<string, unknown> = {}) => {
    const dialogRef = dialogService.open(dialogComponent, {
      inputValues,
      showHeader: false,
      maskStyleClass: 'backdrop-blur-xs !pointer-events-auto',
    });
    return dialogRef!.onClose.pipe(map((result) => result as R | undefined));
  };
